import React, {useCallback, useEffect, useState} from 'react';
import Toast from "react-bootstrap/Toast";
import {format} from "date-fns";
import {Bell, CircleCheck, Danger, Info} from "./Font";
import {emitter} from "../services/API";

export type NotificationType = 'success' | 'danger' | 'warning' | 'info';

export type NotificationData = {
    id?: string,
    msg : string,
    type: NotificationType,
    time?: string,
    onClose?: () => void,
}

const Notifications = () => {

    const [data, setData] = useState([]);

    const listener = useCallback((newNotification : NotificationData)=>{
        setData(prevData => [...prevData, newNotification]);
    }, []);

    const removeNotification = useCallback((id: string) => {
        setData(prevData => prevData.filter((item) => item.id !== id));
    }, []);

    useEffect(()=>{
        emitter.on('notification', listener);
        return ()=>{
            emitter.removeListener('notification', listener);
        }
    }, []);

    return <div className="notifications-wrapper">
        {
            data.map((n, index)=> {
                if (!n.msg) { console.log('wrong notification received'); return null; }
                const notificationId = n.id || `${n.time || 'notification'}-${index}`;
                return <NotificationToast key={notificationId} {...n} onClose={()=>{removeNotification(notificationId)}}/>
            })
        }
    </div>
}

Notifications.pushNew = (msg: string, type: NotificationType = 'info')=>{
    emitter.emit(Notifications.Event, {
        id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        msg,
        type,
        time: format(new Date(), 'HH:mm:ss')
    })
}
Notifications.Event = 'notification';

// let cnt = 0;
// setInterval(()=>{
//      if (cnt > 3) return;
//     console.log('pushing msg' + cnt)
//     Notifications.pushNew('jakas wiadomość: ' + ++cnt, Math.random() < 0.5 ? 'info': 'danger');
// }, 3000)

export default Notifications;


const getNotificationMeta = (type: NotificationType) => {
    switch (type) {
        case 'danger':
            return {label: 'Błąd', icon: <Danger />};
        case 'success':
            return {label: 'Sukces', icon: <CircleCheck />};
        case 'warning':
            return {label: 'Uwaga', icon: <Bell />};
        default:
            return {label: 'Informacja', icon: <Info />};
    }
}

const NotificationToast = (props: NotificationData) => {
    const meta = getNotificationMeta(props.type);

    return (
        <Toast
            className={`notification-toast toast-${props.type}`}
            onClose={props.onClose}
            delay={NotificationToast.DELAY_AUTOHIDE}
            autohide
            role={props.type === 'danger' ? 'alert' : 'status'}>
            <Toast.Header className="notification-toast-header">
                <div className="notification-toast-icon">
                    {meta.icon}
                </div>
                <div className="notification-toast-heading">
                    <strong className="notification-toast-title">{meta.label}</strong>
                    {!!props.time && <small className="notification-toast-time">{props.time}</small>}
                </div>
            </Toast.Header>
            <Toast.Body className="notification-toast-body">
                <div className="notification-toast-message" dangerouslySetInnerHTML={{ __html: props.msg}}></div>
            </Toast.Body>
        </Toast>
    );
}

NotificationToast.DELAY_AUTOHIDE = 5000;
